import React from "react";
import { ButtonGroup, Modal } from "react-bootstrap";
import { MyButton } from "components/button";
import "./modal.scss";

const RejectedTransactionModal = ({ show, onHide, errorMessage }) => {
  return (
    <Modal
      show={show}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="text-holder text-center">
          <h4>Transaction Cancelled</h4>
          <p>{errorMessage}</p>
        </div>

        <ButtonGroup>
          <MyButton
            className="custom-btn md dark"
            text="cancel"
            handleClick={onHide}
          />
        </ButtonGroup>
      </Modal.Body>
    </Modal>
  );
};

export default RejectedTransactionModal;
